<template>
  <div class="relative flex flex-col justify-center items-center h-full">
    <section-title titlePath="title-5.png" />
    <div
      class="flex flex-row flex-wrap justify-center w-full max-w-1280 mt-9 lg:px-40 lg:mt-0"
    >
      <a
        v-for="(skill, index) in skillData"
        :key="index"
        class="w-348 h-195 m-1 rounded-sm lg:w-272 lg:h-40"
        data-lity
        :href="skill.link"
        :style="{
          'background-image':
            'url(' + imgPath + '/slide6/legendskill_' + (index + 1) + '.png)',
        }"
      ></a>
    </div>
    <a
      class="seeMore-btn mt-10 rounded-full w-52 h-14 flex items-center justify-center border border-soft-orange text-soft-orange font-elmessiri text-xl bg-opacity-40 bg-black cursor-pointer hover:text-black"
      href="https://www.youtube.com/watch?v=R6OxfQMwBEc&list=PLocrE_Fv_pj4fiGj6j_iPZ3ZHPZHsmNtY"
      target="_blank"
      >See More</a
    >
  </div>
</template>

<script>
import SectionTitle from '../components/SectionTitle/SectionTitle.vue';
export default {
  components: { SectionTitle },
  data: function() {
    return {
      imgPath: process.env.VUE_APP_IMG_URL,
      skillData: [
        { link: 'https://youtu.be/teb2ac_CFl0' },
        { link: 'https://youtu.be/L6F0iRptoxk' },
        { link: 'https://youtu.be/DaIUxkxFlEM' },
        { link: 'https://youtu.be/YgZNLJbes_s' },
        { link: 'https://youtu.be/GoY7kj9SE-0' },
        { link: 'https://youtu.be/cyX9Wc94sH8' },
      ],
    };
  },
};
</script>

<style lang="postcss" scoped>
.seeMore-btn:hover {
  background: linear-gradient(157.96deg, #feecbc 0%, #c5a576 100%);
}
</style>
